import { render, staticRenderFns } from "./ScanFormDPHead.vue?vue&type=template&id=2f7b1d64&scoped=true"
import script from "./ScanFormDPHead.vue?vue&type=script&lang=js"
export * from "./ScanFormDPHead.vue?vue&type=script&lang=js"
import style0 from "./ScanFormDPHead.vue?vue&type=style&index=0&id=2f7b1d64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b1d64",
  null
  
)

export default component.exports